import SvgIcon from '@/components/SvgIcon/index.vue' // Svg Component
import 'virtual:svg-icons-register'
import { type App } from 'vue'

export function loadSvg(app: App) {
  app.component('SvgIcon', SvgIcon)
}
